import React, { useContext, useEffect, useMemo } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { getAgentIncentiveRingsDetails } from "../../../store/actions";
import { DataTableLoader, TableLoader } from "../../../utils/Loader";
import { isNullOrEmpty } from "../../../utils";

const CustomTileChartModal = ({ showModal, toggleModal }) => {
  const dispatch = useDispatch();
  const { activeOrganizationInfo, agentInsentiveRingDetail, isFetching } =
    useSelector(
      ({
        get_active_organization_detail: { data: activeOrganizationData },
        get_agent_incentive_rings_details: {
          data: agentInsentiveRingData,
          isFetching,
        },
      }) => {
        return {
          activeOrganizationInfo: activeOrganizationData || {},
          agentInsentiveRingDetail: agentInsentiveRingData || [],
          isFetching: isFetching,
        };
      },
      shallowEqual,
    );

  useEffect(() => {
    dispatch(
      getAgentIncentiveRingsDetails({
        companyguid: activeOrganizationInfo?.Companyguid,
        organization: activeOrganizationInfo?.Organization,
        primaryprogram: activeOrganizationInfo?.Program,
        employeeid: activeOrganizationInfo?.Employeeid,
        recordtype: activeOrganizationInfo?.Type,
        recorddate: activeOrganizationInfo?.FrameData?.transdate,
      }),
    );
  }, [dispatch]);
  const closeBtn = (
    <div
      className="links_right"
      style={{ position: "absolute", top: "15px", right: "15px" }}
    >
      <button
        className="modal_close bg-transparent"
        onClick={toggleModal}
        type="button"
      >
        <img src="/images/cross.svg" alt="close" />
      </button>
    </div>
  );

  const groupedData = useMemo(() => {
    if (!agentInsentiveRingDetail || agentInsentiveRingDetail.length === 0)
      return [];

    const grouped = agentInsentiveRingDetail.reduce((acc, item) => {
      if (!acc[item.category]) acc[item.category] = [];
      acc[item.category].push(item);
      return acc;
    }, {});

    return Object.keys(grouped)
      .map((category) => ({
        category,
        items: grouped[category].sort(
          (a, b) => a.metricdisplayorder - b.metricdisplayorder,
        ),
        categoryOrder: Math.min(
          ...grouped[category].map((x) => x.categorydisplayorder),
        ),
      }))
      .sort((a, b) => a.categoryOrder - b.categoryOrder);
  }, [agentInsentiveRingDetail]);

  return (
    <Modal
      isOpen={showModal}
      toggle={toggleModal}
      backdrop={true}
      keyboard={true}
      external={closeBtn}
      style={{ maxWidth: "90%", width: "700px" }}
      id="incentive-rings-modal"
    >
      <ModalHeader className="custom-modal metric_header border-0">
        <div className="flex space-between align-center">
          <div className="inc_hd modal-title"> Incentive Rings Detail</div>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="p-0">
          {isFetching ? (
            <div className="text-center">
              <TableLoader width={700} />
            </div>
          ) : (
            <table className="table">
              <thead>
                <tr className="irm-thead">
                  <th style={{ textAlign: "left", minWidth: "160px" }}>
                    Ring / Metric
                  </th>
                  <th className="text-center">Actual</th>
                  <th className="text-center">Goal</th>
                  <th className="text-center">Cap</th>
                  <th className="text-center">% to Goal</th>
                </tr>
              </thead>

              <tbody>
                {groupedData.map((group, index) => (
                  <React.Fragment key={index}>
                    {/* Parent Row (Category) */}
                    <tr className="irm-parent">
                      <td colSpan="5" style={{ textAlign: "left" }}>
                        {group.category}
                      </td>
                    </tr>

                    {/* Child Rows */}
                    {group.items.map((item, idx) => (
                      <tr className="irm-child" key={item.metricid || idx}>
                        <td style={{ textAlign: "left" }}>{item.metricname}</td>
                        <td className="text-center">
                          {!isNullOrEmpty(item.actualvalue)
                            ? Number(item.actualvalue).toFixed(2)
                            : ""}
                        </td>
                        <td className="text-center">{item.goal}</td>
                        <td className="text-center">{item.capvalue}</td>
                        <td className="text-center">
                          {!isNullOrEmpty(item.percentagetogoal)
                            ? `${item.percentagetogoal}%`
                            : ""}
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default CustomTileChartModal;
